import { useState } from 'react';
import { Button, TableCell, Tooltip } from '@material-ui/core';
import { withRouter } from 'react-router';
import TaskManagerLastResultDialog from './TaskManagerLastResultDialog';

const maxLength = 20;

function TaskManagerLastResultField(props) {
	const { item } = props;
	const [showDialog, setShowDialog] = useState(false);
	const lastResult = item?.lastResult;
	const hasLastResult = lastResult !== null && lastResult !== undefined;
	const canOpenDialog = hasLastResult && typeof lastResult !== 'string';

	const getLabel = (short) => {
		let str = '-';

		if (typeof lastResult === 'string') {
			str = lastResult;
		} else if (hasLastResult) {
			str = '';
			if (lastResult?.class) str += lastResult.class;
			if (lastResult?.message) {
				if (str !== '') str += ' - ';
				str += lastResult.message;
			}
			if (str === '') str = typeof lastResult === 'object' ? 'Details available' : String(lastResult);
		}

		if (str !== '-' && short) str = str.substring(0, maxLength) + (str.length > maxLength ? '...' : '');

		return str;
	};

	return (
		<TableCell className="w-auto">
			{canOpenDialog ? (
				<>
					<Tooltip title={getLabel()} placement='bottom'>
						<span>
							<Button
								className='whitespace-nowrap'
								variant='contained'
								color='primary'
								onClick={(event) => {
									event.stopPropagation();
									setShowDialog(true);
								}}
							>
								Show
							</Button>
						</span>
					</Tooltip>
					{showDialog && (
						<TaskManagerLastResultDialog
							item={item}
							data={lastResult}
							onClose={() => setShowDialog(false)}
						/>
					)}
				</>
			) : (
				<Tooltip title={getLabel()} placement='bottom'>
					<div className='whitespace-nowrap overflow-hidden overflow-ellipsis'>{getLabel(true)}</div>
				</Tooltip>
			)}
		</TableCell>
	);
}

export default withRouter(TaskManagerLastResultField);
